<template>
    <div class="search-container row" v-if="true">
        <form @submit.prevent="submit" novalidate>
            <div class="gap">
                <div>
                    <search-radio class="inline-block" value="oneWay" v-model="type">
                        یک طرفه
                    </search-radio>
                    <search-radio class="inline-block" value="twoWay" v-model="type">
                        رفت و برگشت
                    </search-radio>
                    <search-radio class="inline-block" value="multiCity" v-model="type">
                        چند مسیره
                    </search-radio>
                </div>
            </div><!-- /radio -->

            <template v-if="!isMultiDestination">
                <div class="col-xs-12 col-md-5">
                    <div class="input-pair input-pair--switch">
                        <international-destination-picker
                            v-model="origin"
                            ref="origin"
                            placeholder="مبدا (شهر یا فرودگاه)"
                            :filter="getDestinationFilter(null)"
                            :tabindex="1"
                            data-test="originPicker"
                        >
                            <template slot="option" slot-scope="props">
                                <search-result v-if="props.option && !props.option.$isLabel" :item="props.option" :query="props.query" />
                            </template>
                        </international-destination-picker>

                        <button type="button" name="button" @click="switchOriginDestination()" aria-label="Switch places">
                            <i class="icon icon-switch" />
                        </button>

                        <international-destination-picker
                            v-model="destination"
                            ref="destination"
                            placeholder="مقصد (شهر یا فرودگاه)"
                            :filter="getDestinationFilter(null, 'origin')"
                            :tabindex="2"
                            data-test="destinationPicker"
                        >
                            <template slot="option" slot-scope="props">
                                <search-result v-if="props.option && !props.option.$isLabel" :item="props.option" :query="props.query" />
                            </template>
                        </international-destination-picker>
                    </div>
                </div>

                <div class="col-xs-12 col-md-3 col-lg-3 search-date">
                    <date-picker ref="datepicker" v-model="datePickerValue" :range.sync="isRangeDatePicker" :jalaali.sync="isJalaali">
                        <div class="input-pair xs" slot-scope="{ open, focus, value }">
                            <div class="input-group" :class="{ focus: focus === 0 }" data-test="departingDatePicker">
                                <span class="input-group-addon" @click="open(0)"><i class="icon icon-calendar" /></span>
                                <input :value="value[0] ? value[0].format(isJalaali ? 'jYYYY/jMM/jDD' : 'YYYY/MM/DD') : null"
                                       placeholder="تاریخ رفت"
                                       class="form-control"
                                       tabindex="3"
                                       readonly
                                       @click="open(0)"
                                >
                            </div>
                            <div class="input-group" :class="{ disabled: type !== 'twoWay', focus: focus === 1 }" data-test="returningDatePicker" @click="onReturningClick() || open(1)">
                                <span class="input-group-addon" @click="open(1)"><i class="icon icon-calendar" /></span>
                                <input :value="value[1] ? value[1].format(isJalaali ? 'jYYYY/jMM/jDD' : 'YYYY/MM/DD') : null"
                                       placeholder="تاریخ برگشت"
                                       class="form-control"
                                       :disabled="type !== 'twoWay'"
                                       tabindex="4"
                                       readonly
                                       @click="open(1)"
                                >
                            </div>
                        </div>

                        <template slot="day" slot-scope="props" v-if="$device.desktop">
                            <span v-tooltip="tooltipOptions(props)" class="calendar__day__content">{{ props.day.format(isJalaali ? 'jD' : 'D') }}</span>
                        </template>
                    </date-picker>
                </div>

                <div class="col-xs-12 col-md-2">
                    <international-passenger-picker ref="passengers" v-model="passengers" :type.sync="flightClass" :max-passengers="maxPassengers" :tabindex="5" />
                </div>

                <div class="col-xs-12 col-md-2">
                    <search-btn class="domestic-search" :disabled="!isCompleted" :loading="!isCompleted" :tabindex="6" />
                </div>
            </template>

            <template v-else>
                <template v-for="(trip, i) in trips">
                    <div :key="i" class="row mx-0 mb-2 multidestination-item">
                        <span class="icon-close clickable" @click="trips.splice(i, 1)" v-show="trips.length > 2" />
                        <h6 class="visible-xs visible-sm px-1 mb-1 mt-0">
                            مسیر {{ i + 1 | persianOrdinal }}
                        </h6>
                        <div class="col-xs-12 col-md-8">
                            <div class="input-pair input-pair--switch">
                                <international-destination-picker
                                    v-model="trip.origin"
                                    ref="origin"
                                    :placeholder="'مبدا مسیر ' + persianOrdinal(i + 1)"
                                    :filter="getDestinationFilter(i, 'destination')"
                                    :tabindex="1 + i * 3"
                                >
                                    <template slot="option" slot-scope="props">
                                        <search-result v-if="props.option && !props.option.$isLabel" :item="props.option" :query="props.query" />
                                    </template>
                                </international-destination-picker>

                                <button type="button" name="button" @click="switchOriginDestination(trip)" aria-label="Switch places">
                                    <i class="icon icon-switch" />
                                </button>

                                <international-destination-picker
                                    v-model="trip.destination"
                                    ref="destination"
                                    :placeholder="'مقصد مسیر ' + persianOrdinal(i + 1)"
                                    :tabindex="2 + i * 3"
                                    :filter="getDestinationFilter(i, 'origin')"
                                    @input="fillNext(i)"
                                >
                                    <template slot="option" slot-scope="props">
                                        <search-result v-if="props.option && !props.option.$isLabel" :item="props.option" :query="props.query" />
                                    </template>
                                </international-destination-picker>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-12 col-md-4 search-date">
                            <date-picker ref="datepicker"
                                         :value="trip.departing ? [$moment(trip.departing, DATE_FORMAT)] : [null]"
                                         :range="false" :jalaali.sync="isJalaali"
                                         :min-date="getMultiDestinationMinDate(i)"
                                         @input="trip.departing = $event[0] ? $event[0].format(DATE_FORMAT) : null"
                                         auto-close
                                         alignment="left"
                            >
                                <div slot-scope="{ focus, open, value }" class="input-group" :class="{ focus: focus === 0 }" data-test="departingDatePicker">
                                    <span class="input-group-addon" @click="open(0)"><i class="icon icon-calendar" /></span>
                                    <input :value="value && value[0] ? value[0].format(isJalaali ? 'jYYYY/jMM/jDD' : 'YYYY/MM/DD') : null"
                                           placeholder="تاریخ رفت"
                                           class="form-control"
                                           :tabindex="3 + i * 3"
                                           readonly
                                           @input="fillNext(i)"
                                           @click="open(0)"
                                    >
                                </div>
                            </date-picker>
                        </div>
                    </div>
                    <hr :key="'h' + i" class="visible-xs visible-sm my-3 mx-1">
                </template>

                <div class="row mx-0 pb-1 mb-3">
                    <div class="col-xs-12 col-md-8">
                        <template v-if="trips.length < 5">
                            <button type="button" class="btn btn-primary" :class="{ 'btn-outline btn-block': $device.mobile }" @click="addTrip">
                                &plus;
                                افزودن مسیر
                            </button>
                        </template>
                    </div>
                    <div class="col-xs-12 col-md-2">
                        <international-passenger-picker ref="passengers" v-model="passengers" :type.sync="flightClass" :max-passengers="maxPassengers" :tabindex="5" />
                    </div>
                    <div class="col-xs-12 col-md-2">
                        <search-btn class="domestic-search" :disabled="!isCompleted" :loading="!isCompleted" :tabindex="6" />
                    </div>
                </div>
            </template>
        </form>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { dp } from '~/vendors/amibdatepicker';
import { convertToJD } from '~/scripts/utils';
import persianOrdinal from '~/scripts/filters/persian-ordinals';
// Mixins
import api from '~/scripts/mixins/international/api';
import common from '~/scripts/mixins/international/common';
import { commonErrors, internationalErrors } from '~/scripts/utils/errors';
import get from 'lodash/get';
// child components
import SearchResult from '~/components/pages/international/search/search-result';
import SearchPanel from '~/components/common/search/search-panel';
import InternationalPassengerPicker from './international-passenger-picker';
import InternationalDestinationPicker from './international-destination-picker';

const createTrip = () => ({
    origin: { name: '', domainCode: '' },
    destination: { name: '', domainCode: '' },
    departing: null,
});

export default {
    components: {
        SearchResult,

        InternationalPassengerPicker,
        InternationalDestinationPicker,
    },
    extends: SearchPanel,
    mixins: [
        api,
        common,
    ],
    data () {
        return {
            type: 'twoWay',
            origin: { name: '', domainCode: '' },
            destination: { name: '', domainCode: '' },
            adult: 1,
            child: 0,
            infant: 0,
            departing: '',
            returning: '',
            flightClass: 'economy',
            openPassengers: false,
            selectedOrigin: '',
            selectedDestination: '',
            hasError: { // add has-error class to field if user not import data on it
                origin: false,
                destination: false,
            },
            searchedText: '',

            // Multi Destination
            trips: [createTrip(), createTrip()],
        };
    },
    computed: {
        ...mapState('international', [
            'maxPassengers',
            'isCompleted',
        ]),

        passengers: {
            get () {
                const { adult, child, infant } = this;
                return { adult, child, infant };
            },

            set (x) {
                Object.assign(this.$data, x);
            },
        },
    },
    watch: {
        type: {
            immediate: true,
            handler (t, f) {
                // If OneWay, clear Returning Date
                if (t === 'oneWay' && this.returning) {
                    this.returning = '';
                }

                this.$nextTick(() => {
                    const { origin, destination, datepicker, passengers } = this.$refs;
                    if (t !== 'multiCity' && (!f || f === 'multiCity')) {
                        this.autoNextInput([origin, destination, datepicker, passengers].filter(Boolean));
                    } else if (t === 'multiCity') {
                        this.trips.forEach((el, i) => {
                            this.autoNextInput([origin[i], destination[i], datepicker[i]].filter(Boolean));
                        });
                    }
                });
            },
        },
        origin (data) {
            if (data && data.domainCode) {
                if (this.destination && this.destination.domainCode === data.domainCode) {
                    this.destination = { name: '', domainCode: '' };
                }
            }
        },
        destination (data) {
            if (data && data.domainCode) {
                if (this.origin && this.origin.domainCode === data.domainCode) {
                    this.origin = { name: '', domainCode: '' };
                }
            }
        },
    },
    mounted () {
        this.$setTimeout(() => {
            this.setInitialValues();
        }, 20);
        this.$root.$on('indra::international.searchChanged', () => {
            this.setInitialValues();
        });
    },

    validations () {
        return !this.isMultiDestination ? {
            origin: {
                name: {
                    required,
                },
            },
            destination: {
                name: {
                    required,
                },
            },
            departing: {
                required,
            },
        } : {
            trips: {
                iranFirst: v => v && get(v, '0.origin.city.country.name') === 'Iran',
            },
        };
    },
    methods: {
        ...mapActions('international', ['getAirports']),
        ...mapActions(['openAlert']),
        ...mapMutations('international', [
            'setOrigin',
            'setOriginName',
            'setOriginCityName',
            'setOriginCountryName',
            'setDestination',
            'setDestinationName',
            'setDestinationCityName',
            'setDestinationCountryName',
            'setType',
            'setDeparting',
            'setDepartingJd',
            'setReturning',
            'setReturningJd',
            'setAdult',
            'setChild',
            'setInfant',
            'setFlightClass',
            'setIsCompleted',
            'setMultiDestinationTrips',
        ]),
        completeLabel ({ domainCode, city, name }) {
            if (name !== '') {
                return city ? `${city.name}, ${domainCode.substr(0, 3)}` : '';
            }
        },
        checkValidInput () {
            const trips = (this.isMultiDestination ? this.trips : [{
                origin: this.origin,
                destination: this.destination,
                departing: this.departing,
            }]);

            for (const trip of trips) {
                if (!trip.origin.domainCode) {
                    this.openAlert(commonErrors.emptyOrigin);
                    return false;
                }
                if (!trip.destination.domainCode) {
                    this.openAlert(commonErrors.emptyDestination);
                    return false;
                }
                if (!trip.departing) {
                    this.openAlert(commonErrors.emptyDeparting);
                    return false;
                }
            }
            if (this.isMultiDestination && !this.$v.trips.iranFirst) {
                this.openAlert('شروع پرواز باید از ایران باشد');
                return false;
            }
            return true;
        },
        onReturningClick () {
            this.type = 'twoWay';
        },
        switchOriginDestination (trip) {
            trip = trip || this;
            const temp = trip.origin;
            trip.origin = trip.destination;
            trip.destination = temp;
        },

        getMultiDestinationMinDate (index) {
            let previousTrip = null;
            while (!(previousTrip && previousTrip.departing) && index > 0) {
                previousTrip = this.trips[--index];
            }
            return previousTrip && previousTrip.departing ? this.$moment.utc(previousTrip.departing, this.DATE_FORMAT) : this.$moment.utc();
        },

        submit () {
            // check valid data inputs
            if (!this.checkValidInput()) {
                return false;
            }
            this.$v.$touch();

            if (this.isMultiDestination) {
                if (this.trips.length === 1) {
                    this.type = 'oneWay';
                    Object.assign(this, this.trips[0]);
                    this.returning = null;
                } else if (this.trips.length === 2 && this.trips[0].origin.domainCode === this.trips[1].destination.domainCode && this.trips[0].destination.domainCode === this.trips[1].origin.domainCode) {
                    this.type = 'twoWay';
                    Object.assign(this, this.trips[0]);
                    this.datePickerValue = [this.trips[0].departing].concat(this.trips[1].departing);
                } else {
                    this.setMultiDestinationTrips(this.trips.slice());
                }
            } else {
                this.type = this.departing && this.returning ? 'twoWay' : 'oneWay';
                if (this.origin.domainCode === this.destination.domainCode) {
                    this.openAlert(internationalErrors.sameOriginDestination);
                    return false;
                }
            }

            if (!this.$v.$invalid) {
                // send search tracking event
                this.sendSearchTrackingEvent('Submission');
                // This Function Resets "informationError" And "failed" Flags On Each Clean Search
                this.$emit('reset-errors', false);
                this.setIsCompleted(false);
                this.setType(this.type);
                this.setOrigin(this.origin.domainCode);
                this.setOriginName(this.origin.name);
                this.setDestination(this.destination.domainCode);
                this.setDestinationName(this.destination.name);
                this.setDeparting(this.departing);
                this.setReturning(this.returning);
                this.setAdult(this.adult);
                this.setChild(this.child);
                this.setInfant(this.infant);
                this.setFlightClass(this.flightClass);
                this.$emit('close-search-box');
                this.$emit('create-new-search');
                // set last search in the local storage
                this.$storage.setLocalStorage('internationalSearchInfo', {
                    type: this.type,
                    origin: this.origin,
                    destination: this.destination,
                    departing: this.departing,
                    returning: this.returning,
                    adult: this.adult,
                    child: this.child,
                    infant: this.infant,
                    flightClass: this.flightClass,
                });
            }
        },
        // this lines of codes are copy from train search panel
        findAirport (domainCode) {
            return (this.cities || []).find(station => station.domainCode === domainCode);
        },
        setInitialValues () {
            // Initiate data from store
            const { type, origin, departing, returning, destination, adult, child, infant } = this.$store.state.international;
            this.type = type;
            this.departing = departing;
            this.returning = returning;
            this.adult = adult;
            this.child = child;
            this.infant = infant;

            // By default we have extracted value of destination
            // So we need to update both local state and store
            // get last search data from local storage
            const internationalSearchInfo = this.$storage.getUniversal('internationalSearchInfo');
            if (internationalSearchInfo && internationalSearchInfo !== 'undefined' && this.$route.name === 'index-iranout') {
                this.origin = internationalSearchInfo.origin;
                this.destination = internationalSearchInfo.destination;
                this.type = internationalSearchInfo.type;
                this.adult = internationalSearchInfo.adult;
                this.child = internationalSearchInfo.child;
                this.infant = internationalSearchInfo.infant;
                this.flightClass = internationalSearchInfo.flightClass;
                // checked departing date has not expired yet
                if (convertToJD(internationalSearchInfo.departing) >= dp.getTodayJD()) {
                    this.departing = internationalSearchInfo.departing;
                    this.returning = internationalSearchInfo.returning;
                } else {
                    this.departing = '';
                    this.returning = '';
                }
            }
            // اگر به صورت مثال

            // مقدار مبدا را بتوانیم پیدا کنیم یعنی مقدار مقصد را نیر پیدا کرده ایم به صورت پیشفرض
            // پس در این حالت میباست هم مقدار انها در لوکال این کامپوننت درج شود و هم در استور با مقادیر نام و کد انها درج شوند
            if (origin && destination) {
                const notEmpty = o => o && Object.keys(o).length;
                if (notEmpty(this.findAirport(origin)) && notEmpty(this.findAirport(destination))) {
                    const originAirport = this.findAirport(origin);
                    const destinationAirport = this.findAirport(destination);
                    this.origin = originAirport;
                    this.destination = destinationAirport;
                    this.setOriginName(originAirport.name);
                    this.setDestinationName(destinationAirport.name);
                    this.setOriginCityName(originAirport.city.name || '');
                    this.setOriginCountryName(originAirport.city.country.name || '');
                    this.setDestinationCityName(destinationAirport.city.name || '');
                    this.setDestinationCountryName(destinationAirport.city.country.name || '');
                } else {
                    this.getAirport(origin)
                        .then((airport) => {
                            if (airport) {
                                this.origin = airport;
                                this.setOriginName(airport.name);
                            }
                        });
                    this.getAirport(destination)
                        .then((airport) => {
                            if (airport) {
                                this.destination = airport;
                                this.setDestinationName(airport.name);
                            }
                        });
                }
            }
            // check dates, if they are empty then initialize them with query values if the query value are sent
            if (!this.departing && this.$route.query.departing) {
                this.departing = this.$route.query.departing;
            }
            // check dates, if they are empty then initialize them with query values if the query value are sent
            if (!this.returning && this.$route.query.returning) {
                this.returning = this.$route.query.returning;
            }
            this.setDeparting(this.departing);
            this.setReturning(this.returning);
            if (typeof (this.departing) !== 'object') {
                this.setDepartingJd(convertToJD((this.departing || '').replace(/-/g, '/')));
            }
            this.setReturningJd(convertToJD((this.returning || '').replace(/-/g, '/')));
        },

        addTrip () {
            this.trips.push(createTrip());
            const i = this.trips.length - 1;
            this.fillNext(i - 1);
            this.$nextTick(() => {
                const { origin, destination, datepicker } = this.$refs;
                this.autoNextInput([origin[i], destination[i], datepicker[i]]);
            });
        },

        fillNext (index) {
            const trip = this.trips[index + 1];
            if (!trip) return;
            if (!trip.origin || !trip.origin.domainCode) {
                trip.origin = this.trips[index].destination;
            }
            if (!trip.departing && this.trips[index].departing) {
                const date = this.$moment(this.trips[index].departing, this.DATE_FORMAT).add(7, 'days');
                trip.departing = date.isValid() ? date.format(this.DATE_FORMAT) : null;
            }
            if ((!trip.destination || !trip.destination.domainCode) && this.trips.length > 2) {
                trip.destination = this.trips[0].origin;
            }
        },

        // Filter iran cities if origin or destination set to Iran
        // Filter Same Domain Code
        // Type: origin, destination
        getDestinationFilter (tripIndex, type) {
            return el => {
                try {
                    const airport = (tripIndex != null ? this.trips[tripIndex] : this)[type];
                    return el.domainCode !== airport.domainCode && (airport.city.country.name !== 'Iran' || el.city.country.name !== 'Iran');
                } catch (e) {}
                return true;
            };
        },

        sendSearchTrackingEvent (label) {
            // temporarily disable search tracking events due to farid's requests
            if (label) return;
            // search tracking
            this.$gtm.sendGTMEvent({
                event: 'event',
                eventCategory: 'Search Tracking',
                eventAction: 'International Flight',
                eventLabel: label,
            });
        },

        persianOrdinal,
    },
};
</script>

<style lang="scss" scoped>
@import '~vars';

.search-container {

    @media (min-width: 992px) {
        position: relative;
        z-index: 10;
    }

    .multidestination-item {
        position: relative;

        .icon-close {
            float: left;
            color: $gray;
            margin-top: -8px;
            padding: 10px;

            @media (min-width: 992px) {
                margin-top: 0;
                position: absolute;
                left: -30px;
                top: 5px;
                color: $snow-white;
            }
        }

        ~ hr {
            border-style: dashed;
        }
    }

    &--light {

        .multidestination-item .icon-close {
            color: $gray;
        }
    }
}
</style>
